import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "./styles.module.scss";
import { FormAreas } from "../components/FormAreas";
import { IArea } from "../../../../@types/area.type";
import { getAreaById } from "../../../../services/api/areas/AreasService";
import { IApiResponse } from "../../../../@types/api-response.type";
import CircularProgress from "@mui/material/CircularProgress";
import { useSyncActive } from "../../../../utils/useSyncActive";

export const UpdateAreas: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [area, setArea] = useState<IArea>({} as IArea);
  const { id } = useParams();
  const navigate = useNavigate();

  const isSyncActive = useSyncActive();

  async function fechAreaById() {
    try {
      setLoading(true);

      if (!id) {
        toast.error("ID da área não fornecido!");
        navigate("/*");
        return;
      }

      const response = await getAreaById(id) as IApiResponse<IArea>;

      if (!response.result) {
        toast.error("Área não encontrado!");
        navigate("/*");
        return;
      }

      setArea(response.result);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar o Cliente!");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fechAreaById();
  }, [id]);

  return (
    <>
      {loading ? (
        <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress size={100} />
      </div>
      ) : (
        <div className={styles.updateCustomer}>
          <FormAreas pageType="update" areaData={area} isSyncActive={isSyncActive} />
        </div>
      )}
    </>
  );
};
